import React from "react";
import {Card, CardContent, Checkbox, FormControlLabel, Grid} from "@mui/material";
import {FileCard} from "~/apps/core/ui/FileCard";
import {Controller, useFormContext} from "react-hook-form";
import {Type, Values} from "./PassForm";

export type AgreementFormCardProps = {
    types: Type[]
}


export const AgreementFormCard = (props: AgreementFormCardProps) => {
    const {types} = props;
    const {control, errors} = useFormContext<Values>();

    return (
        <Card>
            <CardContent>
                <Grid container direction="column" spacing={2} wrap="nowrap">
                    <Grid item>
                        <FileCard
                            type="download"
                            name="Правила поведения пешеходов"
                            format="PDF"
                            size={1286087}
                            uri="/docs/Правила поведения пешеходов.pdf"
                        />
                    </Grid>
                    {types.includes("CAR") && (
                        <Grid item>
                            <FileCard
                                type="download"
                                name="Правила поведения для водителей автомашин"
                                format="PDF"
                                size={1478065}
                                uri="/docs/Правила поведения водителей.pdf"
                            />
                        </Grid>
                    )}
                    <Grid item>
                        <Controller
                            name="agreement"
                            control={control}
                            rules={{required: "Обязательно для заполнения"}}
                            render={({onChange, value, name, ref}) => (
                                <FormControlLabel
                                    control={<Checkbox
                                        checked={value}
                                        onChange={e => {
                                            onChange(e.target.checked)
                                        }}
                                        sx={Boolean(errors?.[name]) && {
                                            color: '#E53328',
                                            '& + span': {
                                                color: '#E53328!important',
                                            }
                                        }}
                                    />}
                                    label="Ознакомлен с документами"

                                />
                            )}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}
